import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import DescriptionIcon from '@material-ui/icons/Description';
import {
  CardHeader,
  Card,
  Grid,
  Typography,
  makeStyles,
} from '@material-ui/core';
import Wrapper from '../components/Wrapper';

const useStyles = makeStyles((theme) => ({
  iconContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  fileTitle: {
    fontSize: '1.5rem !important',
    fontWeight: '500',
    color: 'black',
    '& a': {
      color: 'black !important',
    },
    '& a:hover': {
      textDecoration: 'underline',
    },
  },
  icon: {
    fontSize: '3rem',
  },
  cardHeader: {
    fontWeight: 'bold',
  },
  listItem: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
}));

const FilePlugin = () => {
  const classes = useStyles();
  return (
    <Card>
      <CardHeader title='Pliki do pobrania' className={classes.cardHeader} />
      {typeof plugin_files_config !== 'undefined' &&
        Object.keys(plugin_files_config?.displayed_files ?? {}).map((key) => {
          const file = plugin_files_config?.displayed_files?.[key];
          return Object.keys(file).length > 0 ? (
            <Grid container className={classes.listItem}>
              <Grid item xs={1} className={classes.iconContainer}>
                <DescriptionIcon className={classes.icon} />
              </Grid>
              <Grid item xs={11}>
                <Grid item xs={12}>
                  <Typography variant='h2' className={classes.fileTitle}>
                    <a
                      aria-label={`Pobierz plik ${file?.name}`}
                      href={`${window.location.origin}/media/${file.path}`}
                      color='textPrimary'
                      download
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      {file?.name}
                    </a>
                  </Typography>
                </Grid>
                <Grid item xs={12}>
                  <Typography>
                    Rozmiar: {file?.size}MB &nbsp;&nbsp; Pobrano: {file?.count}
                  </Typography>
                </Grid>
              </Grid>
              {file?.value}
            </Grid>
          ) : (
            ''
          );
        })}
    </Card>
  );
};

export default FilePlugin;

ReactDOM.render(
  <Wrapper productionPrefix={'fip'} seed={'file-plugin'}>
    <FilePlugin />
  </Wrapper>,
  document.getElementById('files-to-download'),
);
